import { render, staticRenderFns } from "./LabelTemplate.vue?vue&type=template&id=7204411c&scoped=true&"
import script from "./LabelTemplate.vue?vue&type=script&lang=js&"
export * from "./LabelTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204411c",
  null
  
)

export default component.exports